import React from 'react';
import { fieldNames } from '../../config';
import StartDateField from './StartDateField/StartDateField';
import PlanEndDateField from './PlanEndDateField/PlanEndDateField';
import EndDateField from './EndDateField/EndDateField';
import TypeField from './TypeField/TypeField';
import ReasonField from './ReasonField/ReasonField';
import InitiatorsField from './InitiatorsField/InitiatorsField';
import ResponsibleField from './ResponsibleField/ResponsibleField';
import AlisaTemplateField from './AlisaTemplateField/AlisaTemplateField';
import AlisaTextField from './AlisaTextField/AlisaTextField';
import DescriptionField from './DescriptionField/DescriptionField';
import UploadFilesField from './UploadFilesField/UploadFilesField';
import AddressesField from './AddressesField/AddressesField';
import NotifyToField from './NotifyToField/NotifyToField';
import EnableAlisaField from './EnableAlisaField/EnableAlisaField';
import CitiesField from './CitiesField/CitiesField';
import MainInitiatorField from './MainInitiatorField/MainInitiatorField';
import CompanyField from './CompanyField/CompanyField';

const dateTimeFieldProps = {
  showTime: { format: 'HH:mm', minuteStep: 10 },
  format: 'DD.MM.YYYY HH:mm',
};

export const ShutdownField = ({
  name,
  renderResTemplateAction,
  renderResTemplateOptionActions,
  ...props
}) => {
  switch (name) {
    case fieldNames.startDate:
      return (
        <StartDateField
          fieldProps={dateTimeFieldProps}
          {...props}
        />
      );

    case fieldNames.planEndDate:
      return (
        <PlanEndDateField
          fieldProps={dateTimeFieldProps}
          {...props}
        />
      );

    case fieldNames.endDate:
      return (
        <EndDateField
          fieldProps={dateTimeFieldProps}
          {...props}
        />
      );

    case fieldNames.type:
      return <TypeField {...props} />;

    case fieldNames.city:
      return <CitiesField {...props} />;

    case fieldNames.company:
      return <CompanyField {...props} />;

    case fieldNames.reason:
      return <ReasonField {...props} />;

    case fieldNames.initiators:
      return <InitiatorsField {...props} />;

    case fieldNames.mainInitiator:
      return <MainInitiatorField {...props} />;

    case fieldNames.responsible:
      return <ResponsibleField {...props} />;

    case fieldNames.alisaTemplate:
      return (
        <AlisaTemplateField
          renderAction={renderResTemplateAction}
          renderOptionActions={renderResTemplateOptionActions}
          {...props}
        />
      );

    case fieldNames.alisaText:
      return <AlisaTextField {...props} />;

    case fieldNames.description:
      return <DescriptionField {...props} />;

    case fieldNames.files:
      return <UploadFilesField {...props} />;

    case fieldNames.addresses:
      return <AddressesField {...props} />;

    case fieldNames.notifyTo:
      return <NotifyToField {...props} />;

    case fieldNames.enableAlisa:
      return <EnableAlisaField {...props} />;

    default:
      return null;
  }
};
